import React from 'react';

interface ResourceNodeTooltipProps {
  name: string;
  requirement?: string;
  x: number;
  y: number;
  visible: boolean;
}

export const ResourceNodeTooltip: React.FC<ResourceNodeTooltipProps> = ({
  name,
  requirement,
  x,
  y,
  visible,
}) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: `${x}px`,
        top: `${y}px`,
        pointerEvents: 'none',
        zIndex: 200,
        transform: 'translate(-50%, -100%)',
        marginTop: '-8px',
      }}
    >
      <div
        style={{
          background: '#0d1117',
          border: '2px solid #2ecc71',
          borderRadius: '4px',
          padding: '8px 12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5), 0 0 8px rgba(46, 204, 113, 0.2)',
          backdropFilter: 'blur(4px)',
          animation: 'fadeIn 0.12s ease-out',
        }}
      >
        <div
          style={{
            fontFamily: '"Sometype Mono", monospace',
            fontSize: '9px',
            color: '#c9d1d9',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </div>
        {requirement && (
          <div
            style={{
              fontFamily: '"Sometype Mono", monospace',
              fontSize: '7px',
              color: '#ffd700',
              marginTop: '4px',
              whiteSpace: 'nowrap',
            }}
          >
            {requirement}
          </div>
        )}
      </div>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translate(-50%, -100%) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -100%) scale(1);
          }
        }
      `}</style>
    </div>
  );
};
